<template>
    <div id="transactionCompletePage" class="container bg-white px-0 py-5">
        <div class="lazada-hc-logo"></div>
        <hr class="customDivider my-3" />
        <div class="d-flex flex-column align-items-center text-center p-2">
            <img
                alt=""
                src="/img/hcpay/transaction-complete-icon-2.svg"
                class="transactionCompleteIcon img-responsive"
            />
            <span class="font-md font-weight-bold text-capitalize my-3"
                >Transaction Complete!</span
            >
            <span class="font-sm text-secondary">
                <!-- Go to Lazada Wallet Top-up and enter the code<br />below to complete your top-up -->
                Please check your e-wallet account for your<br />updated balance
            </span>
            <span class="font-lg font-weight-bold mt-4 mb-2"
                >₱ {{ this.$root.$data.amount }}</span
            >
            <span class="font-sm text-secondary my-2"
                >has been successfully paid to</span
            >
            <span class="font-sm font-weight-bold text-capitalize mb-3"
                >Lazada</span
            >
            <span class="font-sm text-secondary">from your</span>
            <span class="font-sm font-weight-bold mt-2 mb-3">{{
                $root.$data.paymentOptionLabel
            }}</span>
        </div>
        <hr class="customDivider my-3" />
        <div class="px-4 mt-4 mb-5">
            <div class="d-flex flex-column">
                <div class="d-flex align-items-center justify-content-between">
                    <span
                        class="font-sm font-weight-bold text-capitalize text-gray-dk padding-buttom-16"
                        >Purchase Details</span
                    >
                </div>
                <div
                    class="d-flex align-items-center justify-content-between mt-4"
                >
                    <span
                        class="font-sm font-weight-bold text-capitalize text-gray-dk padding-buttom-16"
                        >Recipient</span
                    >
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <span class="font-sm text-secondary">{{
                        $root.$data.account.recipient
                    }}</span>
                </div>
                <div
                    class="d-flex align-items-center justify-content-between mt-4"
                >
                    <span
                        class="font-sm font-weight-bold text-capitalize text-gray-dk padding-buttom-16"
                        >Notes</span
                    >
                </div>
                <div class="d-flex align-items-center justify-content-between">
                    <span class="font-sm text-secondary"
                        >Please make sure you have your Lazada Wallet
                        activated.<br />
                        Funds will be transfered to your nominated e-wallet
                        account<br />
                        immediately. Transaction cannot be reversed.</span
                    >
                </div>
            </div>
        </div>
        <hr class="customDivider my-3" />
        <div class="px-4 mt-4 mb-5">
            <lazada-payment-summary class="mx-auto" :dropdown="true" />
        </div>
        <div class="d-flex flex-column justify-content-center text-center px-5">
            <span
                class="font-xs font-weight-bold text-gray-dk text-capitalize mb-2"
                >Reference No. {{ this.$root.$data.referenceNumber }}</span
            >
            <span class="font-xs font-weight-bold text-secondary mb-4">{{
                $root.$data.transaction.transDateTime | moment
            }}</span>
            <div class="px-5">
                <button
                    type="button"
                    id="transactionCompleteBackToStore"
                    @click="backToStore"
                    class="btn btn-success btn-block rounded-lg py-2 mb-3"
                >
                    Back to Lazada
                </button>
            </div>
            <button
                type="button"
                id="transactionCompleteShareFeedback"
                class="btn btn-link-success font-weight-bold font-sm text-green text-capitalize"
                @click="openQualtrics()"
                v-if="qualtricsEnabled"
            >
                Share Feedback
            </button>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    data() {
        const qualtricsBtnEl = document.getElementById("QSIFeedbackButton-btn");
        return {
            qualtricsEnabled: !!qualtricsBtnEl,
        };
    },
    created() {
        this.$root.$data.complete = true;
        this.$root.$data.previousView = "transaction-complete";
        let g4Params = {
            userId: this.$root.$data.account.userId,
            cuid: this.$root.$data.account.cuid,
            ip: this.$root.transaction.ipAddress,
            user_agent: this.$root.$data.analyticsData.userAgent,
            phone: this.$root.$data.analyticsData.phone,
            operating_system:
                this.$root.$data.analyticsData.operatingSystem.name +
                "V" +
                this.$root.$data.analyticsData.operatingSystem.version,
            browser:
                this.$root.$data.analyticsData.browser.name +
                "V" +
                this.$root.$data.analyticsData.browser.version,
            transaction_type: "WT",
            transaction_reference: this.$root.$data.referenceNumber,
        };
        this.$root.triggerG4Event("transaction_complete_page", g4Params);
    },
    computed: {
        amount() {
            let val = (this.$root.$data.transaction.amount / 1)
                .toFixed(2)
                .replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
    },
    methods: {
        gotoFeedBack() {
            let g4Params = {
                userId: this.$root.$data.account.userId,
                cuid: this.$root.$data.account.cuid,
                ip: this.$root.transaction.ipAddress,
                user_agent: this.$root.$data.analyticsData.userAgent,
                phone: this.$root.$data.analyticsData.phone,
                operating_system:
                    this.$root.$data.analyticsData.operatingSystem.name +
                    "V" +
                    this.$root.$data.analyticsData.operatingSystem.version,
                browser:
                    this.$root.$data.analyticsData.browser.name +
                    "V" +
                    this.$root.$data.analyticsData.browser.version,
                transaction_type: "WT",
                transaction_reference: this.$root.$data.referenceNumber,
            };
            this.$root.triggerG4Event("goto_feedback_page", g4Params);
            this.changeView("feedback");
        },
        backToStore() {
            let g4Params = {
                userId: this.$root.$data.account.userId,
                cuid: this.$root.$data.account.cuid,
                ip: this.$root.transaction.ipAddress,
                user_agent: this.$root.$data.analyticsData.userAgent,
                phone: this.$root.$data.analyticsData.phone,
                operating_system:
                    this.$root.$data.analyticsData.operatingSystem.name +
                    "V" +
                    this.$root.$data.analyticsData.operatingSystem.version,
                browser:
                    this.$root.$data.analyticsData.browser.name +
                    "V" +
                    this.$root.$data.analyticsData.browser.version,
                transaction_type: "WT",
                transaction_reference: this.$root.$data.referenceNumber,
            };
            this.$root.triggerG4Event("back_to_lazada", g4Params);
            window.location.href =
                "https://pages.lazada.com.ph/wow/gcp/route/lazada/ph/upr_1000345_lazada/channel/ph/upr-router/render?hybrid=1&data_prefetch=true&prefetch_replace=1&at_iframe=1&wh_pid=/lazada/channel/ph/lazada-wallet-loans/LazadaLoans";
        },
        changeView(view) {
            this.$root.$data.view = view;
        },
        autoBackToStore() {
            setInterval(() => {
                let g4Params = {
                    userId: this.$root.$data.account.userId,
                    cuid: this.$root.$data.account.cuid,
                    ip: this.$root.transaction.ipAddress,
                    user_agent: this.$root.$data.analyticsData.userAgent,
                    phone: this.$root.$data.analyticsData.phone,
                    operating_system:
                        this.$root.$data.analyticsData.operatingSystem.name +
                        "V" +
                        this.$root.$data.analyticsData.operatingSystem.version,
                    browser:
                        this.$root.$data.analyticsData.browser.name +
                        "V" +
                        this.$root.$data.analyticsData.browser.version,
                    transaction_type: "WT",
                    transaction_reference: this.$root.$data.referenceNumber,
                };
                this.$root.triggerG4Event(
                    "auto_back_to_lazada_event",
                    g4Params
                );

                window.location.href =
                    "https://pages.lazada.com.ph/wow/gcp/route/lazada/ph/upr_1000345_lazada/channel/ph/upr-router/render?hybrid=1&data_prefetch=true&prefetch_replace=1&at_iframe=1&wh_pid=/lazada/channel/ph/lazada-wallet-loans/LazadaLoans";
            }, 20000);
        },
        openQualtrics() {
            const qualtricsBtnEl = document.getElementById(
                "QSIFeedbackButton-btn"
            );
            if (!qualtricsBtnEl) {
                return;
            }
            qualtricsBtnEl.click();
        },
    },
    filters: {
        moment: function (date) {
            return moment(date).format("DD MMM YYYY | hh:mm a").toUpperCase();
        },
    },
    mounted() {
        this.autoBackToStore();
    },
};
</script>
<style scoped>
.transactionCompleteIcon {
    height: auto;
    width: 7rem;
}
.lazada-hc-logo {
    /* Layout Properties */
    top: 14px;
    left: 36px;
    width: 100%;
    height: 52px;
    /* UI Properties */
    background: transparent url("/img/lazada/logos_desktop.png") center
        no-repeat padding-box;
    opacity: 1;
}
.instructions {
    top: 744px;
    width: 288px;
    height: 16px;
    text-align: left;
    font-size: 14px;
    font-weight: Bold;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    letter-spacing: 0px;
    color: #000000de;
    opacity: 1;
}
.lazada-icon-content {
    text-align: left;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
        Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
    font-size: 14px;
    color: #000000de;
    opacity: 1;
}
.icon-one {
    /* Layout Properties */
    left: 22px;
    width: 48px;
    height: 48px;
    /* UI Properties */
    background: transparent url("/img/lazada/one-icon.svg") 50% 10% no-repeat
        padding-box;
    opacity: 1;
}
.icon-two {
    /* Layout Properties */
    left: 22px;
    width: 48px;
    height: 48px;
    /* UI Properties */
    background: transparent url("/img/lazada/two-icon.svg") 50% 30.5% no-repeat
        padding-box;
    opacity: 1;
}
.icon-three {
    /* Layout Properties */
    left: 22px;
    width: 48px;
    height: 48px;
    /* UI Properties */
    background: transparent url("/img/lazada/three-icon.svg") 50% 10% no-repeat
        padding-box;
    opacity: 1;
}
</style>
